import React from 'react'
import type { BankCardButton } from '../types'
import { PaymentMethodButtonStyled } from '../PaymentMethodButton.styled'
import { BankCardDisplay } from './BankCardDisplay'
import { makeAccessibleName } from './helpers'
import { Visa } from '../../Icons'

const issuerName = 'Visa'

export const VisaButton: BankCardButton = ({ lastFour, disabled, onClick }) => {
  return (
    <PaymentMethodButtonStyled
      provider='visa'
      aria-label={makeAccessibleName(issuerName, lastFour)}
      disabled={disabled}
      onClick={onClick}
    >
      <Visa />
      <BankCardDisplay issuerName={issuerName} lastFour={lastFour} />
    </PaymentMethodButtonStyled>
  )
}
